import React from 'react';
import { Briefcase, Mail, Linkedin, Twitter, Calendar, MapPin, Award, Layers, Users } from 'lucide-react';
export const Portfolio = () => {
  return <div className="w-full bg-white min-h-screen" data-id="element-2404">
      {/* Hero Section */}
      <section className="pt-20 pb-16 border-b border-gray-200" data-id="element-2405">
        <div className="container mx-auto px-4" data-id="element-2406">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-2407">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-2408">
              <div className="w-64 h-64 border-2 border-gray-300 rounded-full overflow-hidden" data-id="element-2409">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sGA11gNJc7vxEwMehjwPFv/dreyyyy.jpg" alt="Andrew Igbineweka" className="w-full h-full object-cover grayscale" loading="eager" width="256" height="256" data-id="element-2410" />
              </div>
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-2411">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-2412">
                Andrew Igbineweka
              </h1>
              <h2 className="text-2xl text-gray-600 mb-6" data-id="element-2413">
                Human Capital Development Professional
              </h2>
              <p className="text-gray-600 mb-6 max-w-2xl" data-id="element-2414">
                Passionate about connecting people to networks, ideas, and
                opportunities. Experienced in community building, strategic
                partnerships, and talent development.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-2415">
                <a href="mailto:andrew@example.com" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2416">
                  <Mail size={16} className="text-gray-600" data-id="element-2417" />
                  <span data-id="element-2418">Contact</span>
                </a>
                <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2419">
                  <Linkedin size={16} className="text-gray-600" data-id="element-2420" />
                  <span data-id="element-2421">LinkedIn</span>
                </a>
                <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2422">
                  <Twitter size={16} className="text-gray-600" data-id="element-2423" />
                  <span data-id="element-2424">Twitter</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-2425">
        <div className="container mx-auto px-4" data-id="element-2426">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-2427">
            About Me
          </h2>
          <div className="flex flex-col md:flex-row gap-12" data-id="element-2428">
            <div className="w-full md:w-2/3" data-id="element-2429">
              <p className="text-gray-600 mb-6" data-id="element-2430">
                I am a Human Capital Development Professional with expertise in
                community building, strategic partnerships, and talent
                development. My work focuses on connecting young professionals
                to networks, ideas, and opportunities worldwide.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-2431">
                As the founder of The Networking Salon, I've built communities
                across multiple cities, creating platforms for meaningful
                connections and professional growth.
              </p>
              <p className="text-gray-600" data-id="element-2432">
                My approach combines strategic thinking with human-centered
                design, creating systems and experiences that help individuals
                and organizations thrive in today's rapidly evolving landscape.
              </p>
            </div>
            <div className="w-full md:w-1/3" data-id="element-2433">
              <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-2434">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2435">
                  Details
                </h3>
                <ul className="space-y-4" data-id="element-2436">
                  <li className="flex items-center gap-3" data-id="element-2437">
                    <Calendar size={20} className="text-gray-500" data-id="element-2438" />
                    <div data-id="element-2439">
                      <p className="text-sm text-gray-500" data-id="element-2440">Experience</p>
                      <p className="text-gray-700" data-id="element-2441">7+ Years</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-2442">
                    <MapPin size={20} className="text-gray-500" data-id="element-2443" />
                    <div data-id="element-2444">
                      <p className="text-sm text-gray-500" data-id="element-2445">Location</p>
                      <p className="text-gray-700" data-id="element-2446">Nigeria</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-2447">
                    <Award size={20} className="text-gray-500" data-id="element-2448" />
                    <div data-id="element-2449">
                      <p className="text-sm text-gray-500" data-id="element-2450">Education</p>
                      <p className="text-gray-700" data-id="element-2451">
                        MBA, University of Nigeria
                      </p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-2452">
                    <Layers size={20} className="text-gray-500" data-id="element-2453" />
                    <div data-id="element-2454">
                      <p className="text-sm text-gray-500" data-id="element-2455">Focus Areas</p>
                      <p className="text-gray-700" data-id="element-2456">
                        Community Building, Strategic Partnerships, Talent
                        Development
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Tools Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-2457">
        <div className="container mx-auto px-4" data-id="element-2458">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-2459">
            Tools & Skills
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2460">
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-2461">
              <div className="flex items-center gap-3 mb-4" data-id="element-2462">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-2463">
                  <div size={20} className="text-gray-600" data-id="element-2464" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2465">
                  Strategic Planning
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2466">
                <li className="flex items-center gap-2" data-id="element-2467">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2468"></div>
                  <span className="text-gray-600" data-id="element-2469">Stakeholder Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2470">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2471"></div>
                  <span className="text-gray-600" data-id="element-2472">SWOT Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2473">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2474"></div>
                  <span className="text-gray-600" data-id="element-2475">Project Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2476">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2477"></div>
                  <span className="text-gray-600" data-id="element-2478">Risk Assessment</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-2479">
              <div className="flex items-center gap-3 mb-4" data-id="element-2480">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-2481">
                  <Users size={20} className="text-gray-600" data-id="element-2482" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2483">
                  Community Building
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2484">
                <li className="flex items-center gap-2" data-id="element-2485">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2486"></div>
                  <span className="text-gray-600" data-id="element-2487">Event Planning</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2488">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2489"></div>
                  <span className="text-gray-600" data-id="element-2490">Member Engagement</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2491">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2492"></div>
                  <span className="text-gray-600" data-id="element-2493">Content Creation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2494">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2495"></div>
                  <span className="text-gray-600" data-id="element-2496">Relationship Management</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-2497">
              <div className="flex items-center gap-3 mb-4" data-id="element-2498">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-2499">
                  <Briefcase size={20} className="text-gray-600" data-id="element-2500" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2501">
                  Business Development
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2502">
                <li className="flex items-center gap-2" data-id="element-2503">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2504"></div>
                  <span className="text-gray-600" data-id="element-2505">Partnership Building</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2506">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2507"></div>
                  <span className="text-gray-600" data-id="element-2508">Negotiation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2509">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2510"></div>
                  <span className="text-gray-600" data-id="element-2511">
                    Client Relationship Management
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2512">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2513"></div>
                  <span className="text-gray-600" data-id="element-2514">Revenue Strategy</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-2515">
              <div className="flex items-center gap-3 mb-4" data-id="element-2516">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-2517">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-2518"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2519">
                  Digital Tools
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2520">
                <li className="flex items-center gap-2" data-id="element-2521">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2522"></div>
                  <span className="text-gray-600" data-id="element-2523">Microsoft Office Suite</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2524">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2525"></div>
                  <span className="text-gray-600" data-id="element-2526">Google Workspace</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2527">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2528"></div>
                  <span className="text-gray-600" data-id="element-2529">Canva</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2530">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2531"></div>
                  <span className="text-gray-600" data-id="element-2532">CRM Systems</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-2533">
              <div className="flex items-center gap-3 mb-4" data-id="element-2534">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-2535">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-2536"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2537">
                  Communication
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2538">
                <li className="flex items-center gap-2" data-id="element-2539">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2540"></div>
                  <span className="text-gray-600" data-id="element-2541">Public Speaking</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2542">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2543"></div>
                  <span className="text-gray-600" data-id="element-2544">Content Writing</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2545">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2546"></div>
                  <span className="text-gray-600" data-id="element-2547">Presentation Design</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2548">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2549"></div>
                  <span className="text-gray-600" data-id="element-2550">Storytelling</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-2551">
              <div className="flex items-center gap-3 mb-4" data-id="element-2552">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-2553">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-2554"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2555">Leadership</h3>
              </div>
              <ul className="space-y-2" data-id="element-2556">
                <li className="flex items-center gap-2" data-id="element-2557">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2558"></div>
                  <span className="text-gray-600" data-id="element-2559">Team Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2560">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2561"></div>
                  <span className="text-gray-600" data-id="element-2562">Mentoring</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2563">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2564"></div>
                  <span className="text-gray-600" data-id="element-2565">Conflict Resolution</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-2566">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-2567"></div>
                  <span className="text-gray-600" data-id="element-2568">Decision Making</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Experience Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-2569">
        <div className="container mx-auto px-4" data-id="element-2570">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-2571">
            Professional Experience
          </h2>
          <div className="space-y-8" data-id="element-2572">
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-2573">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-2574">
                <div data-id="element-2575">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-2576">
                    Founder & CEO
                  </h3>
                  <p className="text-gray-600" data-id="element-2577">The Networking Salon</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-2578">2018 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-2579">
                <li data-id="element-2580">
                  Founded and scaled a global community initiative connecting
                  young professionals across 25+ cities worldwide
                </li>
                <li data-id="element-2581">
                  Developed strategic partnerships with organizations to create
                  opportunities for community members
                </li>
                <li data-id="element-2582">
                  Designed and implemented community-building frameworks and
                  engagement strategies
                </li>
                <li data-id="element-2583">
                  Led a team of city leads and volunteers to execute the vision
                  in multiple locations
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-2584">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-2585">
                <div data-id="element-2586">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-2587">
                    Human Capital Development Consultant
                  </h3>
                  <p className="text-gray-600" data-id="element-2588">Various Organizations</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-2589">2016 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-2590">
                <li data-id="element-2591">
                  Provided strategic guidance on talent development and
                  organizational culture
                </li>
                <li data-id="element-2592">
                  Designed and facilitated leadership development programs and
                  workshops
                </li>
                <li data-id="element-2593">
                  Implemented community-building strategies for corporate
                  clients
                </li>
                <li data-id="element-2594">Advised on employee engagement and retention strategies</li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-2595">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-2596">
                <div data-id="element-2597">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-2598">
                    Community Manager
                  </h3>
                  <p className="text-gray-600" data-id="element-2599">Tech Innovation Hub</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-2600">2015 - 2018</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-2601">
                <li data-id="element-2602">
                  Managed a community of tech entrepreneurs and innovators
                </li>
                <li data-id="element-2603">
                  Organized networking events, workshops, and skill-building
                  programs
                </li>
                <li data-id="element-2604">
                  Facilitated connections between community members and
                  potential investors/partners
                </li>
                <li data-id="element-2605">
                  Created content and communications strategies for community
                  engagement
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Brands Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-2606">
        <div className="container mx-auto px-4" data-id="element-2607">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-2608">
            Brands I've Worked With
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-2609">
            {/* Brand logos would go here - using placeholders for wireframe */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => <div key={item} className="flex items-center justify-center p-4 border border-gray-300 rounded-lg h-24" data-id="element-2610">
                <div className="w-16 h-8 bg-gray-300 rounded-md" data-id="element-2611"></div>
              </div>)}
          </div>
          <p className="text-center text-gray-500 mt-8" data-id="element-2612">
            Note: These are placeholder blocks for brand logos you've worked
            with. You'll need to add actual logos of brands from your
            experience.
          </p>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16" data-id="element-2613">
        <div className="container mx-auto px-4" data-id="element-2614">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-2615">
            Get In Touch
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-2616">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2617">
              <a href="mailto:andrew@example.com" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-2618">
                <Mail size={32} className="text-gray-600 mb-3" data-id="element-2619" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-2620">Email</h3>
                <p className="text-gray-600 text-center" data-id="element-2621">andrew@example.com</p>
              </a>
              <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-2622">
                <Linkedin size={32} className="text-gray-600 mb-3" data-id="element-2623" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-2624">
                  LinkedIn
                </h3>
                <p className="text-gray-600 text-center" data-id="element-2625">andrewigbineweka</p>
              </a>
              <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-2626">
                <Twitter size={32} className="text-gray-600 mb-3" data-id="element-2627" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-2628">
                  Twitter
                </h3>
                <p className="text-gray-600 text-center" data-id="element-2629">@andrewigbineweka</p>
              </a>
            </div>
            <div className="text-center" data-id="element-2630">
              <p className="text-gray-600 mb-6" data-id="element-2631">
                Interested in working together? I'm always open to discussing
                new projects, opportunities and partnerships.
              </p>
              <a href="mailto:andrew@example.com" className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md hover:bg-gray-800 hover:text-white transition-colors" data-id="element-2632">
                <Mail size={18} data-id="element-2633" />
                <span className="font-bold" data-id="element-2634">Send Me a Message</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 border-t border-gray-200 bg-gray-50" data-id="element-2635">
        <div className="container mx-auto px-4 text-center" data-id="element-2636">
          <p className="text-gray-600" data-id="element-2637">
            &copy; {new Date().getFullYear()} Andrew Igbineweka. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
};